declare var __webpack_public_path__: string;

// To account for the shopify url changing, dynamically set the
// public path for code imported at runtime,
__webpack_public_path__ = window.__webpack_public_path__;
export {};
